function variant(value: string | undefined): string {
  if (value === undefined) return 'missing';
  if (value === '') return 'empty';
  return ['on', 'off', 'control'].includes(value) ? value : 'invalid';
}

// Runs before the application telemetry is initialized. This is a local
// diagnostic; a browser log collector is required for Grafana ingestion.
export function logRollout(
  cookieIn: string | undefined,
  effective: string,
  persisted: string | undefined,
) {
  try {
    console.info(
      JSON.stringify({
        event: 'rollout_decision',
        schema_version: 1,
        service: 'login-front',
        experiment: 'lean_pdp',
        country: 'BR',
        stage: 'decision',
        route_type: 'auth',
        cookie_name: 'ff_lean_pdp_v4',
        cookie_in: variant(cookieIn),
        evaluated_variant: null,
        effective_variant: variant(effective),
        decision_source: cookieIn ? 'cookie' : 'fallback',
        reason: !cookieIn
          ? 'cookie_missing_or_empty'
          : variant(cookieIn) === 'invalid'
            ? 'invalid_cookie'
            : 'cookie_reused',
        action: effective === 'on' ? 'redirect_lean_attempt' : 'serve_legacy',
        cookie_written: !cookieIn && persisted === effective,
        cookie_write_failed: !cookieIn && persisted !== effective,
        cookie_ttl_seconds: !cookieIn ? 7200 : null,
      }),
    );
  } catch {
    // Logging must never interrupt login or redirect.
  }
}
